//页面地址绝对路径
export const APP_INFO = {
    //应用注册
    AppRegister: {
        appcode: '102202APP',
        pagecode: '102202APP_PAGE',
        url: '/workbenchsetting/pages/developmentconfig/AppRegister/index.html'
    }, 
    //模板设置-集团
    TemplateSetting: {
        appcode: '10180TM',
        pagecode: '10180TM_PAGE',
        url: '/workbenchsetting/pages/customizeconfig/TemplateSetting/index.html'
    }, 
    //模板设置-业务单元
    TemplateSettingUnit: {
        appcode: '10181TM',
        pagecode: '10181TM_PAGE',
        url: '/workbenchsetting/pages/customizeconfig/TemplateSetting-unit/index.html'
    }, 
}

export const WidgetSidePath = '/nccloud/resources/business_component/widgetSide/publicSetting/main/index.js';